@if(breadcrumbs && breadcrumbs.length > 0 && !isAuthRoute()){
  <nav aria-label="breadcrumb" class="pb-5">
    <ol class="breadcrumb">
      @for(breadcrumb of breadcrumbs; track breadcrumb.url; let last=$last){
        <li class="breadcrumb-item">
          @if(!last){
            <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a><span class="breadcrumb-seperator">|</span>
          } @else {
            <span class="breadcrumb-item">{{ breadcrumb.label }}</span>
          }
        </li>
      }
    </ol>
  </nav>
}
